import React from 'react'
import { Link } from 'react-router-dom'
import { Input, Checkbox } from 'app/theme/forms'

const formatPhone = str => {
  const clean = ('' + str).replace(/\D/g, '');
  const match = clean.match(/^(\d{3})(\d{1,3})?(\d{1,4})?(.*)/)

  if (!match) {
    return clean ? `(${clean}` : ''
  } else if (match[3]) {
    return `(${match[1]}) ${match[2]}-${match[3]}${match[4]}`
  } else if (match[2]) {
    return `(${match[1]}) ${match[2]}`
  } else {
    return `(${match[1]}) `
  }
}

export default function LeadContact(props) {
  const { data, setData, errors, setErrors } = props

  return (
    <div>
      <div className="p-8 pb-10">
        <div className="grid gap-6 m-auto lg:w-2/3">
          <Input
            autoFocus
            data-test-id='first-name'
            value={data.contact.first_name}
            error={errors?.first_name}
            placeholder="First Name"
            classNames={{
              input: 'input-underline',
            }}
            onChange={first_name => {
              setErrors(prev => ({
                ...prev,
                first_name: null,
              }))
              setData(prev => ({
                ...prev,
                contact: {
                  ...prev.contact,
                  first_name,
                }
              }))
            }}
          />
          <Input
            data-test-id='last-name'
            value={data.contact.last_name}
            error={errors?.last_name}
            placeholder="Last Name"
            classNames={{
              input: 'input-underline',
            }}
            onChange={last_name => {
              setErrors(prev => ({
                ...prev,
                last_name: null,
              }))
              setData(prev => ({
                ...prev,
                contact: {
                  ...prev.contact,
                  last_name,
                }
              }))
            }}
          />
          <Input
            type="email"
            data-test-id='email'
            value={data.contact.email}
            error={errors?.email}
            placeholder="Email Address"
            classNames={{
              input: 'input-underline',
            }}
            onChange={email => {
              setErrors(prev => ({
                ...prev,
                email: null,
              }))
              setData(prev => ({
                ...prev,
                contact: {
                  ...prev.contact,
                  email,
                }
              }))
            }}
          />
          <Input
            type="tel"
            data-test-id='phone-number'
            value={data.contact.phone}
            error={errors?.phone}
            placeholder="Phone Number"
            classNames={{
              input: 'input-underline',
            }}
            onChange={phone => {
              if (phone && phone.length > (data.contact.phone || '').length) {
                phone = formatPhone(phone)
              }
              setErrors(prev => ({
                ...prev,
                phone: null,
              }))
              setData(prev => ({
                ...prev,
                contact: {
                  ...prev.contact,
                  phone,
                }
              }))
            }}
          />
          <Checkbox
            data-test-id='sms-opt-in'
            value={data.contact.sms_opt_in}
            className={[
              'font-light text-sm',
            ]}
            checkboxClassName='mr-2 pl-6'
            checked={data.contact.sms_opt_in}
            onChange={sms_opt_in => {
              setData(prev => ({ ...prev, contact: { ...prev.contact, sms_opt_in } }))
            }}
          >
            <SMSLabelText className='text-sm' />
          </Checkbox>
        </div>
      </div>
    </div>
  )
}

const SMSLabelText = ({className}) => {
  const LinkTo = ({href, children}) => <Link to={{ pathname: href }} target='_blank' className='underline'>{children}</Link>

  return (
    <p className={`m-0 p-0 ${className}`}>
      I agree to receive customer care SMS messages from Roaming Hunger at the number provided related to my event request, 
      including booking calls and reminders. Msg frequency varies. Msg & data rates may apply. Reply STOP to
      opt-out. Please see <a className='underline' target="_blank" rel="noreferrer" href='https://privacy.cptn.co/privacy-policy/6e1b0402-6e56-453c-9c37-de518dddb75d'>Privacy Policy</a> and{' '}
      <LinkTo href='/pages/terms_and_conditions/'>Terms & Conditions</LinkTo>.
    </p>
  )
}